import { FILTERS_FIELD_NAMES, FILTER_OPTION_VALUES } from '../VehicleFilters/vehicleFilters.const';

export const MAP_MULTISELECT_GROUP_OPTIONS_BY_SELECT_NAME = new Map<string, string[]>([
  [FILTERS_FIELD_NAMES.MAKES, [FILTER_OPTION_VALUES.DOMESTIC, FILTER_OPTION_VALUES.IMPORT]],
]);

export const CURRENT_OPTION_VALUE = 'currentOptionValue';
export const ALL_VALUES = 'All';
export const MULTIPLY_VALUES_OPTIONS = [FILTER_OPTION_VALUES.DOMESTIC, FILTER_OPTION_VALUES.IMPORT];
